export const ORDER_SPEED_AUDIT_ACTION_DY = 'ORDER_SPEED_AUDIT_ACTION_DY'
export const ORDER_SET_DISTRIBUTE_GOOD_ACTION_DY = 'ORDER_SET_DISTRIBUTE_GOOD_ACTION_DY'
export const ORDER_QUERY_SPEED_OPTIONS_DY = 'ORDER_QUERY_SPEED_OPTIONS_DY'
export const SUPPLIER_ADD_DiSTRIBUTE = 'supplier_add_distribute'
export const SUPPLIER_LIST_CONTACT = 'SUPPLIER_LIST_CONTACT'
export const SEE_MORE_DISTRIBUTE = 'SEE_MORE_DISTRIBUTE'
export const UPGRADE_VISIT_CARD = 'UPGRADE_VISIT_CARD'
export const SHOPGOODSIMPORT_ADDSTORE_BUTTON = 'SHOPGOODSIMPORT_ADDSTORE_BUTTON'
export const COLUMN_SETTING = 'COLUMN_SETTING'
export const UPGRADE_SUCCESS_TIP = 'UPGRADE_SUCCESS_TIP'
export const GOODS_TAB_GXSP_TIP = 'GOODS_TAB_GXSP_TIP' // 商品管理供销搬家气泡
export const GOODS_TAB_FXSP_TIP = 'GOODS_TAB_FXSP_TIP' // 商品管理分销商品气泡
export const GXSP_SKU_TIP = 'GXSP_SKU_TIP' // 商品管理供销商按 sku tab 小气泡
export const FXSP_SKU_TIP = 'FXSP_SKU_TIP' // 商品管理分销商按 sku tab 小气泡
export const AFTERSALES_SET_DEFAULT_ACCOUNT_TIP = 'AFTERSALES_SET_DEFAULT_ACCOUNT_TIP' // 售后管理设置默认子账号弹框
export const GOODS_INFO_INVENTORY_TIP = 'GOODS_INFO_INVENTORY_TIP' // 基础资料库存提示
export const PHONE_STOCK_PRICE_TIP = 'PHONE_STOCK_PRICE_TIP' // 手机查看价格与库存提示
export const MY_PAETNER_SHOP_WORK_WXBTN = 'MY_PAETNER_SHOP_WORK_WXBTN' // 我的分销小站微信按钮
export const SUPPLIER_STOCK_LIST_CHANGE = 'SUPPLIER_STOCK_LIST_CHANGE' // 供应商变价监控
export const REMOVE_GOODS_SHELF_TIP = 'REMOVE_GOODS_SHELF_TIP' // 引导去下架商品提示
export const AFTERSALES_60_DAYS_TIP = 'AFTERSALES_60_DAYS_TIP' // 售后管理页快捷查询默认60天数据提醒
export const AFTERSALES_60_DAYS_TIP_2 = 'AFTERSALES_60_DAYS_TIP_2' // 售后管理页快捷查询默认60天数据提醒
export const AFTERSALES_ALARM_SUMMARY = 'AFTERSALES_ALARM_SUMMARY' // 售后管理页快捷查询默认60天数据提醒
export const AFTERSALES_STATISTICAL_TIP = 'AFTERSALES_STATISTICAL_TIP' // 售后管理页统计说明
export const WAIT_SUPPLIER_REISSUE_KEY = 'WAIT_SUPPLIER_REISSUE_KEY' // 售后管理页待供应商补发提示
export const AUTO_AGGREE_GOODS_FAIL_KEY = 'AUTO_AGGREE_GOODS_FAIL_KEY' // 售后管理页自动同意退货失败提示
export const AFTERSALE_STATUS_FILTER_NEWIMG = 'afterSale_status_filter_newImg' // 售后管理页二级筛选，new角标，如果点击后消失，则会存在这里面
export const AFTERSALES_INTERCEPT_ZT = 'AFTERSALES_INTERCEPT_ZT' // 售后管理页拦截中通快递
export const ACTUAL_RECEIVED_AMOUNT_CHECKED = 'ACTUAL_RECEIVED_AMOUNT_CHECKED' // 按仓库实际收货金额退款给分销商用户勾选状态
export const AFTERSALES_SHIPPED_INTERCEPT = 'AFTERSALES_SHIPPED_INTERCEPT' // 售后管理页已发货待拦截提示
export const AFTERSALES_LOGISTICS_INTERCEPTION = 'AFTERSALES_LOGISTICS_INTERCEPTION' // 售后管理页物流拦截查询
export const NATURAL_ORDER_DAREN_ALTER = 'NATURAL_ORDER_DAREN_ALTER' // 自如出单达人顶部alert
export const FAVORITES_TIP = 'FAVORITES_TIP' // 收藏商品提示框
export const INTERCEPTION_LOGISTICS_ACTION_RED_DOT = 'InterceptLogisticsActionRedDot' // 发起线上快递拦截红点提示
export const INTERCEPTION_LOGISTICS_ACTION_OFFLINE_RED_DOT = 'InterceptLogisticsActionOfflineRedDot' // 线下拦截红点提示
export const REISSUE_CONFIRM_MODAL_TIP = 'REISSUE_CONFIRM_MODAL_TIP' // 创建补发售后单确认框
export const SMALL_PAID_TIP = 'SMALL_PAID_TIP' // 小额赔付角标
export const AFTER_REFUND_RULE_TIP = 'AFTER_REFUND_RULE_TIP' // 售后规则引导绿色提示
export const EXPRESS_INTERCEPTION_TIP = 'EXPRESS_INTERCEPTION_TIP' // 售后快递拦截授权提示
export const MATCH_LOW_EXPRESS_TIP = 'MATCH_LOW_EXPRESS_TIP' // 匹配低价快递角标提示
export const DRAWBACK_NO_CODE_TIP = 'DRAWBACK_NO_CODE_TIP' // 同意退款无需验证码提示框
export const AFTERSALES_SET_DOT = 'AFTERSALES_SET_DOT' // 售后设置小红点
export const AFTERSALES_SUPPORT_PLATFORM = 'AFTERSALES_SUPPORT_PLATFORMV2' // 支持平台的提示弹窗
export const WORTH_SELL_COLLAPSE = 'WORTH_SELL_COLLAPSE' // 值得卖类名是否展开
export const TABLE_SORT = 'TABLE_SORT' // 表格排序参数本地记录
export const USER_CLICK_REFUND = 'USER_CLICK_REFUND' // 用户点击过【同意仅退款】【同意退货退款】【买家已退货，同意退款】（三个按钮只要有1个点击即可）
export const AFTERSALE_GUIDE_POP = 'AFTERSALE_GUIDE_POP' // 售后引导弹窗自动弹出
export const AFTERSALE_ALERT = 'AFTERSALE_ALERT' // 售后alert提示是否出现
export const AFTERSALE_PLACEFILE_ALERT = 'AFTERSALE_PLACEFILE_ALERT' // 售后归档alert提示是否出现
export const AFTERSALE_PLACEFILE_POP = 'AFTERSALE_PLACEFILE_POP' // 售后归档弹窗是否出现
export const AFTERSALE_ADDRESS_VALID_POP = 'AFTERSALE_ADDRESS_VALID_POP' // 售后地址弹窗是否出现(地址失效)
export const AFTERSALE_ADDRESS_OPEN_HANDLE_AFTERSALE_POP = 'AFTERSALE_ADDRESS_OPEN_HANDLE_AFTERSALE_POP' // 售后地址弹窗是否出现(未开启分销售后)
export const AFTERSALE_ADDRESS_ADDRESS_ERROR_POP = 'AFTERSALE_ADDRESS_ADDRESS_ERROR_POP' // 售后地址弹窗是否出现 (地址异常)
export const TO_DISORDER_ACTION_TIP = 'TO_DISORDER_ACTION_TIP' // 售后转分销订单提示
export const ORDER_AUDIT_ACTION_DY = 'ORDER_AUDIT_ACTION_DY' // 代发订单页 极速推单合并到订单推送的提示
export const MYPARTNERSHOP_SET_NETDISK_TIP = 'MYPARTNERSHOP_SET_NETDISK_TIP' // 分销小站管理网盘提示
export const UPDATE_ONLINE_GOODS_NOTICE_TIP = 'UPDATE_ONLINE_GOODS_NOTICE_TIP' // 美团更新线上店铺商品时提示框

export const BATCH_ASSOCIATED_PACKAGE_TIPS = 'BATCH_ASSOCIATED_PACKAGE_TIPS' // 手机查看价格与库存提示
export const DIR_SELECT_BIND_TIP = 'DIR_SELECT_BIND_TIP'

export const SUPPLIER_PURE_GRADE_MODAL = 'SUPPLIER_PURE_GRADE_MODAL' // 供应侧平台资料引导
export const SUPPLIER_GRADE_MODAL = 'SUPPLIER_GRADE_MODAL' // 分销测平台资料引导
export const DOUBLE_ADDRESS_ORDER_TIP = 'DOUBLE_ADDRESS_ORDER_TIP' // 双地址订单提示
export const RULE_SETTING_PARTNERSHOP_GOODS_TIP = 'RULE_SETTING_PARTNERSHOP_GOODS_TIP' // 分销价格及规则设置小站可见规则提示
export const HOW_SETTING_LABEL = 'HOW_SETTING_LABEL' // 如何设置标签
export const SHELVES_ANALYSIS_GRADE_MODAL = 'SHELVES_ANALYSIS_GRADE_MODAL' // 上架后测爆款创建分析引导
export const SHELVES_ANALYSIS_GRADE_TIME = 'SHELVES_ANALYSIS_GRADE_TIME' // 上架后测爆款创建分析引导弹窗记录时间
export const AFTER_SALE_TIP_LAYOUT = 'AFTER_SALE_TIP_LAYOUT' // 售后布局提示
export const AFTER_SALE_TIP_FIRST = 'DIS_AFTER_SALE_TIP_FIRST' // 售后切换布局提示
export const DIS_AFTER_SALE_TIP_LAYOUT = 'DIS_AFTER_SALE_TIP_LAYOUT' // 分销售后布局提示
export const DIS_AFTER_SALE_TIP_FIRST = 'DIS_AFTER_SALE_TIP_FIRST' // 分销售后切换布局提示
export const ORDER_TIP_LAYOUT = 'ORDER_TIP_LAYOUT' // 订单管理上下布局提示
export const ORDER_TIP_LAYOUT_FIRST = 'ORDER_TIP_LAYOUT_FIRST' // 订单管理左右布局提示
export const SPECIAL_PRICE_SET_KEY = 'SPECIAL_PRICE_SET_KEY' // 特殊客户价格策略
export const GOODS_RULE_NOT_UPDATE = 'GOODS_RULE_NOT_UPDATE' // 商品运营分析很久未更新提示
export const AUTO_EXTEND_SET = 'AUTO_EXTEND_SET' // 自动推广设置 下拉行动点气泡
export const EXTEND_STEP1 = 'EXTEND_STEP1' // 推广给分销商第1步
export const EXTEND_STEP2 = 'EXTEND_STEP2' // 推广给分销商第2步
export const PDD_CLIENT = 'PDD_CLIENT' // 拼多多选择了客户端

export const IS_NEVER_OPEN_DLZ_TIP = 'IS_NEVER_OPEN_DLZ_TIP_NEW' // 开启独立站的引导
export const IS_FIND_GOODS_DEMAND_NEW = 'IS_FIND_GOODS_DEMAND_NEW' // 找货需求引导
export const IS_FIND_GOODS_DEMAND_NEW_DEFAULT_ACTIVE = 'IS_FIND_GOODS_DEMAND_NEW_DEFAULT_ACTIVE' // 找货需求 默认进来选中所以
export const IS_FIND_GOODS_DEMAND_NEW_ADD = 'IS_FIND_GOODS_DEMAND_NEW_ADD' // 找货需求引导 添加新的类目
export const IS_FIND_GOODS_DEMAND_NEW_DEL = 'IS_FIND_GOODS_DEMAND_NEW_DEL' // 找货需求引导 删除已选类目
export const HOME_FIND_COOPER_GUIDE = 'HOME_FIND_COOPER_GUIDE' // 首页寻合作引导
export const FAVORITES_SITE_SUCCESS_TIP = 'FAVORITES_SITE_SUCCESS_TIP' // 收藏小站成功提示框

export const OPERATION_CENTER_SKU = 'OPERATION_CENTER_SKU' // 商品管理分销商品气泡
export const MYPARTNER_SHARE_WEIXIN = 'MYPARTNER_SHARE_WEIXIN' // 分销小站分享到微信
export const ERP_TO_SUPPLIER_MYSHOP = 'ERP_TO_SUPPLIER_MYSHOP' // 从erp跳转到供应链分销小站
export const MANUALLY_SYNC_GOODS = 'MANUALLY_SYNC_GOODS' // 手动同步商品

export const BASEPRICE_LOWER_COSTPRICE_MODAL = 'BASEPRICE_LOWER_COSTPRICE_MODAL' // 设置基本售价小于成本价亏损确认框
export const DISTRIBUTE_GOODS_DELIST_SUCCESS_GUIDE_MODAL = 'DISTRIBUTE_GOODS_DELIST_SUCCESS_GUIDE_MODAL' // 分销小站下架商品成功引导提示
export const MY_SUPPLIER_CANCEL_COOP_TIP = 'MY_SUPPLIER_CANCEL_COOP_TIP' // 我的供应商近7天有X家供应商主动终止合作提示
export const DAREN_SHOPGOODS_SHOP_INFO = 'DAREN_SHOPGOODS_SHOP_INFO' // 达人店铺商品选择记录选择的店铺信息
export const IPC_LAYOUT = 'IPC_LAYOUT' // ipc画面布局信息
export const RECHARGE_CREDIT_REMINDER_TIP = 'RECHARGE_CREDIT_REMINDER_TIP' // 分销商充值选择授信额度提醒
export const AFTER_CHANGE_EXPRESS_TIP_MODAL = 'AFTER_CHANGE_EXPRESS_TIP_MODAL' // 换快递成功后提示弹窗-不再提醒
export const AFTER_CHANGE_GOODS_TIP_MODAL = 'AFTER_CHANGE_GOODS_TIP_MODAL' // 换换商品成功后提示弹窗-不再提醒
export const AFTER_CHANGE_SUPPLY_TIP_MODAL = 'AFTER_CHANGE_SUPPLY_TIP_MODAL' // 指定供应商发货后提示弹窗-不再提醒

export const LIMIT_RED_GOODS_MANAGE = 'limit_goodsManage_3' // 平台资料
export const LIMIT_RED_PARTNER_MANAGE = 'limit_partnerManage_3' // 分销小站

export const AFTER_PUSH_ORDER_SHOW_URGEDELIVER_TIP = 'AFTER_PUSH_ORDER_SHOW_URGEDELIVER_TIP' // 推单成功后显示催供应商发货提示

export const FIND_GOODS_FAST_SELL = 'FIND_GOODS_FAST_SELL'
export const SEEK_COOPERATION_CARD = 'SEEK_COOPERATION_CARD' // 寻合作邀约卡片分层1不再提醒
export const SEEK_COOPERATION_CARD_TWO = 'SEEK_COOPERATION_CARD_TWO' // 寻合作邀约卡片分层2不再提醒
export const SEEK_COOPERATION_BANNER = 'SEEK_COOPERATION_BANNER' // 寻合作邀约banner分层1不再提醒
export const SEEK_COOPERATION_BANNER_TWO = 'SEEK_COOPERATION_BANNER_TWO' // 寻合作邀约banner分层2不再提醒

export const SUPPLIER_HAS_SET_DISCLAIMER_TIP = 'SUPPLIER_HAS_SET_DISCLAIMER_TIP' // 我的分销小站-完善合作说明气泡提示
export const CHANNEL_HOME_LOOK_MORE_GOODS_TIP = 'CHANNEL_HOME_LOOK_MORE_GOODS_TIP' // 分销侧关注商家动态，发现更多好品气泡提示
export const RETURN_ADDRESS_FAIL_REASON_TIP = 'RETURN_ADDRESS_FAIL_REASON_TIP' // 新增「退货地址上传失败原因」分析气泡提示

export const NEWLYWED_ZONE_CHANGE_NOT_SHELVES = 'NEWLYWED_ZONE_CHANGE_NOT_SHELVES' // 爆款专区直接进去选中未铺货
export const HISTORICALNOTES_REMARK = 'HISTORICALNOTES_REMARK' // 最近使用的卖家备注

export const STORAGE_KEY = 'VISIT_CARD_FIND_COOPERATION_1' // 我的分销小站-编辑名片透出入驻寻合作标准的气泡
export const OPEN_WARININGSIZE_TIPS = 'OPEN_WARININGSIZE_TIPS' // 寻合作汰换-预警期tips 当日是否展示警告文案
export const STORE_NOT_SET_DEFAULT_RULE_KEY = 'storeNotSetDefaultRuleKey' // 我的分销小站-设置分销运费可能亏损角标
export const DID_COLSE_DISTRBUTE_NEW_GUIDE = 'DID_COLSE_DISTRBUTE_NEW_GUIDE' // 我的分销小站-是否主动弹过新手引导
export const ADD_DAREN_SAMPLE_ORDER_SELECT_SHOP_MODAL_TIP = 'ADD_DAREN_SAMPLE_ORDER_SELECT_SHOP_MODAL_TIP' // 寄样管理：样品单审核，选择线上店铺后增加风险提醒，并可直接继承至ERP订单
export const MIN_PURCHASE_AMOUNT_TIP = 'MIN_PURCHASE_AMOUNT_TIP' // 我的分销商-批量设置起采金额角标

export const FUND_DETAIL_SUPPLIER_SORT_IKNOW = 'FUND_DETAIL_SUPPLIER_SORT_IKNOW' // 分销资金明细-我的供应商-排序iknow
export const FUND_DETAIL_CHANNEL_SORT_IKNOW = 'FUND_DETAIL_CHANNEL_SORT_IKNOW' // 分销资金明细-我的分销商-排序iknow

export const PLATFORM_POLICY_IKNOW = 'PLATFORM_POLICY_IKNOW' // 平台自动化节点配置

export const SAMPLE_ORDER_SENCE_SHOP = 'SAMPLE_ORDER_SENCE_SHOP' // 新增样品订单 - 归属成本店铺
